import axios from 'axios'
import config from '../config'
import store from "../../store/index"
import { mapToken } from '../staff-helper'

function attachLoadingStatus(source, status) {
    let cnt = status ? 1 : -1;
    store.commit('setLoadingCount', cnt);
    return source;
}
axios.defaults.timeout = config.DEFAULT_TIMEOUT;
// before send
axios.interceptors.request.use(c => {
    let token = JSON.parse(sessionStorage.vuex).token;
    if (token) {
        c = Object.assign({}, c, mapToken(token));
    }
    return attachLoadingStatus(c, true)
},
    ex => Promise.reject(attachLoadingStatus(ex, false)));
axios.interceptors.response.use(resp => attachLoadingStatus(resp, false), ex => Promise.reject(attachLoadingStatus(ex, false)));

export default axios;